import React, { useMemo } from 'react'
import { IonCol, IonRow } from '@ionic/react'
import ChartSummaryRowHeader from './ChartSummaryRowHeader.content'
import { IChartSummaryEventEntry } from '../../store/qaAddendum.types'
import {
  getRecordDateTime,
  getEventKeyValues,
  getEventSummaryText,
  getEventNarrative,
  isEventPta,
} from '../../../utils/qaAddendumChartSummary.util'

interface IChartSummaryEventHeaderProps {
  entry: IChartSummaryEventEntry
}

const ChartSummaryEventHeader: React.FC<IChartSummaryEventHeaderProps> = ({ entry }) => {
  const { time, date, keyValues, summaryText, narrative, isPta } = useMemo(() => {
    const recordDateTime = getRecordDateTime(entry.record)
    const eventKeyValues = getEventKeyValues(entry.sectionHeader, entry.record)
    return {
      time: recordDateTime.time,
      date: recordDateTime.date,
      keyValues: eventKeyValues,
      summaryText: getEventSummaryText(entry.record, eventKeyValues, entry.sectionHeader),
      narrative: getEventNarrative(entry.record),
      isPta: isEventPta(entry.record),
    }
  }, [entry])

  return (
    <ChartSummaryRowHeader title={entry.sectionHeader} time={time} date={date} isPta={isPta}>
      {keyValues ? (
        <IonRow className='qa-addendum-chart-summary-event-key-values ion-align-items-start'>
          {keyValues.map((keyValue) => (
            <IonCol
              key={`${entry.key}-${keyValue.key}`}
              sizeMd='1'
              className={`qa-addendum-event-kv-col${keyValue.hideOnMobile ? ' ion-hide-md-down' : ''}`}>
              <h4 className='grid-keyValue-key'>{keyValue.key}</h4>
              <h3 className='grid-keyValue-value'>{keyValue.value}</h3>
            </IonCol>
          ))}
        </IonRow>
      ) : null}
      {!keyValues && summaryText ? <h3 className='wrap-two-lines fw-400 font-size-14'>{summaryText}</h3> : null}
      {narrative ? <p className='qa-addendum-event-narrative wrap-two-lines'>{narrative}</p> : null}
    </ChartSummaryRowHeader>
  )
}

export default ChartSummaryEventHeader
